<template>
  <div>
    <div>
      <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white;">
        <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
          <div class="mint-searchbar" style="padding: 0">
            <div class="mint-searchbar-inner">
              <i class="mintui mintui-search"/>
              <input type="search" placeholder="搜索" class="mint-searchbar-core" style="color: black" v-model="keyword"/>
              <a class="mint-searchbar-cancel" style="display: none;">取消</a>
            </div>
            <div class="mint-search-list" style="display: none;">
              <div class="mint-search-list-warp"/>
            </div>
          </div>
        </div>
        <div style="float: left;">
          <img src="../assets/images/32/search.png" @click="Search"
               style="margin-right:20px ;padding: 0;margin-top: 0.5rem" height="20"
               width="20"
               slot="icon" alt="">
        </div>
      </header>
    </div>
    <div style="margin-top: 3rem">
      <Cell style="text-align: left" v-for="item in ResultList" :key="item.key_id"
            :title="item.title" v-on:click.native="Details(item.key_id)"/>
      <Cell :title="'共计：'+ResultList.length" v-if="ResultList.length>0"/>
    </div>
    <div class="empty-div" v-if="showEmptyImage">
      <img src="../assets/images/no_data.png" alt=""/>
    </div>
  </div>
</template>

<script>
import {Cell} from "vant";

export default {
  name: "Search",
  components: {
    Cell
  },
  data() {
    return {
      showEmptyImage: false,
      keyword: null,
      searchUrl: null,
      callback: null,
      token: localStorage.getItem('token'),
      ResultList: [],
    }
  },
  mounted() {
    if (this.$route.params.sigle === undefined) {
      this.$router.go(-1)
    } else {
      this.searchUrl = this.$route.params.url
      this.callback = this.$route.params.callback
    }
  },
  methods: {
    Details(key_id) {
      this.callback.query = {key_id: key_id}
      this.$router.push(this.callback)
    },
    Search() {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.searchUrl,
        params: {keyword: that.keyword},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.ResultList = response.data['responseData']
              this.showEmptyImage = this.ResultList.length <= 0;
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
  }
}
</script>

<style scoped>

</style>
